module.exports = __webpack_public_path__ + "img/blade.3521ee11.png";